import Contract from './index'

import ContractPosition from './contractPosition'
import CurrentDelegation from './currentDelegation'
import HistoryDelegation from './historyDelegation'
import ClosingCommission from './closingCommission'
import TransactionRecord from './transactionRecord'
import TransactionSummary from './transactionSummary'
import ContractHistory from './contractHistory'
import ContractAssets from './contractAssets'
import ContractBill from './contractBill'
// import OtcBill from './otcBill'
import SpotBill from './spotBill'
import TransferRecord from './transferRecord'

export default {
  path: '/home/contract',
  component: Contract,
  meta: { titie: '交易管理' },
  children: [
    {
      path: '/home/contractPosition',
      meta: { titie: '当前持仓' },
      component: ContractPosition,
    }, //合约持仓
    {
      path: '/home/currentDelegation',
      meta: { titie: '当前委托' },
      component: CurrentDelegation,
    }, //当前委托
    {
      path: '/home/historyDelegation',
      meta: { titie: '历史委托' },
      component: HistoryDelegation,
    }, //历史委托
    {
      path: '/home/closingCommission',
      meta: { titie: '平仓记录' },
      component: ClosingCommission,
    },
    {
      path: '/home/contractHistory',
      meta: { titie: '历史仓位记录' },
      component: ContractHistory,
    }, //平仓委托
    //平仓委托
    {
      path: '/home/transactionRecord',
      meta: { titie: '开仓记录' },
      component: TransactionRecord,
    }, //成交记录
    {
      path: '/home/transactionSummary',
      meta: { titie: '净盈亏查询' },
      component: TransactionSummary,
    }, //成交汇总
    {
      path: '/home/contractAssets',
      meta: { titie: '资产管理' },
      component: ContractAssets,
    }, //成交汇总
    {
      path: '/home/contractBill',
      meta: { titie: '合约资金流水' },
      component: ContractBill,
    }, //合约资金流水
    // {
    //   path: '/home/otcBill',
    //   meta: { titie: 'otc资金流水' },
    //   component: OtcBill,
    // }, //otc资金流水
    {
      path: '/home/spotBill',
      meta: { titie: 'otc资金流水' },
      component: SpotBill,
    }, //otc资金流水
    {
      path: '/home/transferRecord',
      meta: { titie: '划转记录' },
      component: TransferRecord,
    }, //划转记录
  ],
}
